import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import store from "../../store";
import DiversityForm from "./DiversityForm";

const ProviderComponent: FunctionComponent<unknown> = () => (
  <Provider store={store}>
    <DiversityForm />
  </Provider>
);

export default ProviderComponent;
